import { createApiClient } from '../../../../../api/apiClient';
import { buildOrderRulesRequest } from './requestBuilder';
import {
  CustomerSkuUtilizationResponse,
  OrderRulesCustomerRow,
  OrderRulesDashboardResponse,
  OrderRulesFilterParams,
  OrderRulesSkuRow,
} from './types';

// ─── API: /api/order-rules/customer-sku-utilization ──────────────────────────

export const fetchCustomerSkuUtilization = async (
  params: OrderRulesFilterParams,
  locationIds: string[],
  pagination: { page: number; size: number },
  granularity?: string[],
): Promise<CustomerSkuUtilizationResponse> => {
  const api = createApiClient();
  const body = buildOrderRulesRequest(params, locationIds, pagination, { granularity });
  const res = await api.post<{ data: CustomerSkuUtilizationResponse; success: boolean; message: string }>(
    '/order-rules/customer-sku-utilization',
    body,
  );
  return (res.data as any)?.data ?? res.data;
};

// ─── Normalizer: backend → legacy dashboard shape ────────────────────────────

export const normalizeCustomerSkuUtilizationResponse = (
  data: CustomerSkuUtilizationResponse,
): Pick<OrderRulesDashboardResponse, 'customerUtilization' | 'skuUtilization'> => {
  const records = data.records ?? [];

  const customerUtilization: OrderRulesCustomerRow[] = records.map((row) => ({
    region: row.region ?? '',
    market: row.market ?? '',
    location: row.location ?? '',
    // Customer-granularity records carry the id in `customer` and the name in `customerName`.
    customerBp: row.customerBp ?? row.customer ?? '',
    customer: row.customerName ?? row.customer ?? '',
    enrolledSkus: row.enrolledSkus ?? 0,
    eligibleSkus: row.eligibleSkus ?? 0,
    volumeEligibleSkus: row.lastPeriodSalesVolumeEligibleSkus ?? 0,
    volumeAllSkus: row.lastPeriodSalesVolumeAllSkus ?? 0,
    customerPerformancePct: row.customerPerformancePct,
  }));

  const skuUtilization: OrderRulesSkuRow[] = records.map((row) => ({
    location: row.location ?? '',
    materialNumber: row.materialNo ?? '',
    packageName: row.packageName ?? '',
    description: row.materialDescription ?? '',
    enrolledCustomers: row.enrolledCustomers ?? 0,
    totalLargeFormat: row.totalLargeFormat ?? 0,
    volumeEligibleSkus: row.lastPeriodSalesVolumeEligibleSkus ?? 0,
    volumeAllSkus: row.lastPeriodSalesVolumeAllSkus ?? 0,
    skuPerformancePct: row.skuPerformancePct,
  }));

  return { customerUtilization, skuUtilization };
};
